import { pathOr } from 'ramda'
import history from '@/routes/history'
import type { UserPermission } from './auth.types'
import useAuth, { ActionTypes } from './useAuth'

export default function useRouteCRUDAuthCheck() {
  const { user } = useAuth()

  const routeAuth = pathOr(
    {},
    ['authByUrl', history.location.pathname],
    user
  ) as UserPermission

  return [routeAuth, (actionType: ActionTypes) => true] as [
    UserPermission,
    (act: string) => boolean
  ]
}
